<template>
  <basic-container>
    <div class="fund-detail-container" id="subFundRoot">
      <div class="inner-con">
        <!-- 头部 -->
        <div class="top-line">
          <div class="changeblock">
            <div>
              <!-- <div
                class="historyclass reds"
                v-if="basicInfoData.auditState && basicInfoData.auditState > '2' && basicInfoData.modifiedTime"
              >
                资料变更，变更日期：{{ basicInfoData.modifiedTime.slice(0, 11) }}
              </div> -->
              <div class="historyclass orange" v-if="basicInfoData.auditState && basicInfoData.auditState == '1'">
                审核中
              </div>
              <div class="historyclass" v-if="basicInfoData.auditState && basicInfoData.auditState == '2'">
                {{ basicInfoData.auditTime ? basicInfoData.auditTime.substr(0, 10) : "" }} 审核通过1
              </div>
            </div>
            <div class="project-title">{{ basicInfoData.name }}</div>
          </div>

          <!-- <div v-if="basicInfoData.auditState && basicInfoData.auditState == 0 ">
      
            <el-button
              type="primary"
              :loading="butshengheloading"
              size="small"
              @click="updatastate(true)"
            >
              提交审批
            </el-button>
          </div> -->

          <!-- <div >
            <el-button
              type="primary"
              icon="el-icon-check"
              size="small"
              plain
              @click="auditNext(basicInfoData.id, true)"
            >
              通过
            </el-button>
            <el-button
              type="warning"
              icon="el-icon-close"
              size="small"
              plain
              @click="auditNext(basicInfoData.id, false)"
            >
              退回
            </el-button>
          </div> -->
        </div>


        <!-- <div class="project-status">
          <div class="status-title">审核状态</div>
          <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]">
            {{basicInfoData.auditStatusStr}}
          </div>
        </div> -->

        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="基金详情" name="first">
            <FundDetailForm
              ref="fundDetailForm"
              :id="id"
              :disabled="true"
              :bindData="basicInfoData"
            />

            <!-- <template v-for="(item, index) in buttonConfig">
              <Accessory
                :ref="item.id"
                :fileTitle="item.name"
                :key="`${item.id}-${index}`"
                :id="item.id"
                :idname="item.name"
                :upload="true"
                :projectid="id"
                :fileMenuUrlname="`其他子基金`" 
                :isOnlyFile="true"
              />
            </template> -->
          </el-tab-pane>

          <el-tab-pane class="activelabel" label="项目信息" name="second">
            <div class="el_tab_header">
                 <FundPeojectInfo :fundId="$route.params.id"/>
            </div>
            
          </el-tab-pane>
          <el-tab-pane class="activelabel" label="投资情况" name="third">
            <div class="el_tab_header">
               <BusinessInfo :fundId="$route.params.id"/>
            </div>
            
          </el-tab-pane>
          <el-tab-pane class="activelabel" label="运营情况" name="fourth">
            <BusinessDescriptions
              ref="businessDescriptions"
              :id="id"
              :disabled="true"
              :bindData="basicInfoData"
            />
          
          </el-tab-pane>
          <el-tab-pane class="activelabel" label="投后管理" name="fifth">
          <InvestMentManage
            ref="investMentManage"
            :id="id"
            :disabled="true"
            :bindData="basicInfoData"
            
          />
        </el-tab-pane>
          <el-tab-pane class="activelabel" label="附件信息" name="sixth">
            <Accessory
              idname="子基金文件"
              fatername="子基金管理"
              :showTitle="false"
              :upload="
                basicInfoData.auditState &&
                basicInfoData.auditState == 0 &&
                permission.otherSubFunds_add &&
                userInfo.user_id == basicInfoData.managerUser"
              :projectid="$route.params.id"
            />            
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <Dialogreason
      :passdata="passdata"
      @passcheck="passCheck"
      ref="reasondialog"
    />
    <Dialog :data="basicInfoData" ref="dialogpass" />


    <div class="bottom-container" v-if="basicInfoData.auditState && basicInfoData.auditState == 1 ">
      <div class="button-container">      
        <el-button
          v-if="basicInfoData.auditState == 1&&permission.otherSubFundManage_audit"
          type="primary"
          icon="el-icon-check"
          plain
          @click="auditNext(basicInfoData.id, true)"
        >
          通过
        </el-button>
        <el-button
          v-if="basicInfoData.auditState == 1&&permission.otherSubFundManage_audit"
          type="warning"
          icon="el-icon-close"
          plain
          @click="auditNext(basicInfoData.id, false)"
        >
          退回
        </el-button>
      </div>
    </div>  
    <!-- 电梯 -->
    <!-- <NavigatorBar
      v-if="activeName == 'first'"
      :buttonConfig="buttonConfig"
      rootId="subFundRoot"
    />     -->
  </basic-container>
</template>
<script>
import NavigatorBar from "@/components/navigatorBar/navigatorBar";
import FundPeojectInfo from "@/components/fundComponent/projectInfo"
import BusinessInfo from "@/components/fundComponent/businessInfo"
import BusinessDescriptions from "@/components/fundComponent/businessDescriptions";
import FundDetailForm from "@/views/fund/otherFund/subFundManage/components/form";
import Accessory from "@/components/accessoriesother/fundAccessory";
import Dialogreason from "./components/reason";
import Dialog from "@/components/detail/rzzl_lxj/dialog";
import InvestMentManage from "@/components/fundComponent/investMentManage";

import { getSubFundDetail, fundAuditPass, getSubFundClientDetail } from "@/api/fund/subfunds"
import { mapGetters } from "vuex";
import util from "@/mixins/util";
export default {
  name: 'SubFundNewDetail',
  mixins: [util],
  data() {
    return {
      id: '',
      // 项目信息
      projectData: [],
      // 详细数据
      basicInfoData: {},
      activeName: 'first',
      passData: {
        id: "",
        advise: "",
        pass: false,
      },
      buttonConfig: [{
            id: "el1",
            name: "市决策委员会",
          },
          {
            id: "el2",
            name: "内部决策",
          },
          {
            id: "el3",
            name: "投资协议",
          },
          {
            id: "el4",
            name: "投放审核",
          },
        ],
    }
  },
  components: {
    Accessory,
    BusinessInfo,
    BusinessDescriptions,
    Dialogreason,
    FundPeojectInfo,
    FundDetailForm,
    NavigatorBar,
    Dialog,
    InvestMentManage
    
  },
  computed: {
    ...mapGetters(["permission", "userInfo"])
  },
  mounted() {
    this.startSubFund()
  },
  methods: {
    auditNext(id, type) {
      this.passData.id = id;
      this.$refs.reasondialog.showblock(`${type}`);
    },

    passCheck(data, type) {
      let self = this
      let params = {
        auditAdvise: data.advise,
        auditState: type == 'true'?2: 3,
        id: this.id
      }
      fundAuditPass(params).then((res) => {
        self.querySubFundDetail(self.id)
        self.$message({
          type: "success",
          message: res['data']['msg'],
        });
      });
    },

    startSubFund() {
      this.id = this.$route.params.id
      this.querySubFundDetail(this.id)
    },

    async querySubFundDetail(id) {
      let  res ={}
      // if(this.$route.query && this.$route.query.audit == 'true') {
        res = await getSubFundClientDetail({id})
      // }else {
      //   res = await getSubFundDetail({id: id})
      // }
      let basicInfoData = res.data.data
      if (basicInfoData.auditLog) {
          basicInfoData.auditLogList = JSON.parse(basicInfoData.auditLog);
        }
        basicInfoData.industry = basicInfoData.industry
          ? basicInfoData.industry.split(",")
          : [];
        let dataList = [{ code: "audit_state", name: "auditState" }];
        let dataSource = await this.dictionaryMap(dataList, basicInfoData);
        dataSource.address = dataSource.domicile
          ? dataSource.domicile.split(",")
          : [];
        // let addressList = dataSource.domicile
        //   ? dataSource.domicile.split(",")
        //   : [];
        // dataSource.address = "";
        // addressList.map((item) => {
        //   dataSource.address += CodeToText[item];
        // });
        if (dataSource.basicInvestors&&dataSource.basicInvestors.length > 0) {
          dataSource.basicInvestors.map((item) => {
            if (item.capitals.length == 0) {
              item.capitals.push({});
            }
          });
        } else {
          dataSource.basicInvestors=[]
          dataSource.basicInvestors.push({
            capitals: [{}],
          });
        }
      this.basicInfoData = dataSource;
      let result = await getSubFundDetail({id: dataSource.fundId });
          let resultData=result.data.data
          delete resultData.auditState
          this.basicInfoData={
            ...result.data.data,
            ...this.basicInfoData,
            name:result.data.data.name
           
          }
      // console.info(res.data.data, 'getSubFundDetail')
    }

  }
}
</script>
<style lang="scss" scoped>
.fund-detail-container {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;  
  .inner-con{
    width:97%;
    min-width: 1000px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name{
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
    }
    .project-name:hover{
      color: #409EFF;
      cursor: pointer;
    }
    .project-title{
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
    .project-status{
      .status-title{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 16px;
      }
      .status-content{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
  }
  .comment-container{
    margin-top: 20px;
    /deep/.detail-one{
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    /deep/.comment-container{
      margin-top: 0 !important;
    }
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
      background: #fec03d;
  }
  .color_1::before {
      background: #409eff;
  }
  .color_2::before {
      background: #51d351;
  }
  .color_3::before {
      background: #F56C6C;
  }
  .color_4::before {
      background: #F56C6C;
  }
  .top-line{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .changeblock {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .historyclass {
      background: #19be6b;
      padding: 5px 10px;
      font-size: 10px;
      border-radius: 0 10px 10px 0;
      margin-right: 10px;
      color: #fff;
    }
    .reds {
      background: #f56c6c;
    }
    .orange {
      background: #fec03d;
    }
  }
  /deep/.el-tabs__header {
    // margin-bottom: 15px;
  }
  /deep/ .avue-crud__menu{
    display: none;
  }
}
.bottom-container{
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
    .button-container{
      width: 93%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
/deep/.el-tabs__item {
  font-size: 18px ;
  font-weight: bolder ;
  margin-bottom: 10px ;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}
.el_tab_header {
  margin-top:20px;
}
</style>